import isUndefined from 'lodash/isUndefined';

const getValue = (...args) => args.find(arg => !isUndefined(arg)) || false;

export default getValue;
